module.exports = (__webpack_require__(7))(457);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/angular2-cookie/core.js from dll-reference vendor
// module id = 1204
// module chunks = 0